export const queryKeys = {
  dashboardProjects: (userId: string | null | undefined) => ['dashboardProjects', userId] as const,
  project: (projectId: string | null | undefined) => ['project', projectId] as const,
  projectImages: (projectId: string | null | undefined) => ['projectImages', projectId] as const,
  structureTypeIdBySlug: (slug: string | null | undefined) =>
    ['structureTypeIdBySlug', slug ?? ''] as const,
  stagingPresets: (structureTypeId: string | null | undefined) =>
    ['stagingPresets', structureTypeId ?? ''] as const,
  variantFeedback: (imageId: string | null | undefined, variantIdsKey: string | null | undefined) =>
    ['variantFeedback', imageId ?? '', variantIdsKey ?? ''] as const,
  stagingJobs: (userId: string | null | undefined, status: string[] | null = null) =>
    ['stagingJobs', userId, status?.join('|') ?? 'all'] as const,
  stagedImages: (userId: string | null | undefined) => ['stagedImages', userId] as const,
};
